import { IEventSeoSchema } from 'src/components/workshopAndEvents/workshopEvent/seoConfigForPage/seoConfigSchema'
import {
  IEventDataDetail,
  IEventFromWeeztix,
  IEventShop,
  IPackage,
  IQuery,
  ISeoPage,
  IWorkshopEvent,
} from 'src/interfaces/workshopEvent'
import { IWorkshopEventSchema } from 'src/pages/event-management/WorkshopAndEventFormPage/schema'
import { ApiClient } from './axiosClient'

export const workshopEventApi = {
  getListWorkshopEvent: async (params: IQuery) => {
    return await ApiClient.get<{
      items: IWorkshopEvent[]
      total: number
      page: number
      limit: number
    }>('/events', {
      params: {
        ...params,
      },
    })
  },
  createNew: async (body: IWorkshopEventSchema) => {
    return await ApiClient.post('/events', body)
  },
  updateWorkshopEvent: async (id: string, body: IWorkshopEventSchema) => {
    return await ApiClient.put(`/events/${id}`, body)
  },
  deleteWorkshopEvent: async (id: string) => {
    return await ApiClient.delete(`/events/${id}`)
  },
  getWorkshopEventDetail: async (eventId: string) => {
    return await ApiClient.get<IEventDataDetail>(`/events/${eventId}`)
  },
  //seo
  getPageSeo: async () => {
    return await ApiClient.get<ISeoPage>(`common-contents/seo-event-page`)
  },
  updatePageSeo: async (body: IEventSeoSchema) => {
    return await ApiClient.post<{ commonContent: ISeoPage }>(
      `common-contents/seo-event-page`,
      body
    )
  },
  //weeztix
  getListEventsUpcomingFromWT: async () => {
    return await ApiClient.get<IEventFromWeeztix[]>('weeztix/events?type=upcoming')
  },
  getListEventsFromWT: async () => {
    return await ApiClient.get<IEventFromWeeztix[]>('weeztix/events')
  },
  getListShopFromWT: async (eventId: string) => {
    return await ApiClient.get<IEventShop[]>(`weeztix/events/${eventId}/shops`)
  },

  //package
  getListPackage: async (params?: IQuery) => {
    return await ApiClient.get<{
      items: IPackage[]
      total: number
      page: number
      limit: number
    }>('packages', { params: { ...params } })
  },

  getListTicketPackage: async () => {

  }
}
